<template>
    <div class="convention-sections">
        <div v-for="section in convention.sections" :key="section.__uid">
            <v-card elevation="3" class="main-section">
                <v-row no-gutters>
                    <v-col cols="auto">
                        <convention-sections-lines />
                    </v-col>
                    <v-col>
                        <convention-section :section="section" />
                    </v-col>
                </v-row>
            </v-card>
        </div>
    </div>
</template>

<script>
import ConventionSection from "./ConventionSection.vue";
import sectionsManager from "../../managers/sectionsManager";
import { EventBus } from "src/bus/eventBus";
import scrollManager from "../../managers/scrollManager";
import ConventionSectionsLines from "./ConventionSectionsLines.vue";
import { get } from "lodash";

export default {
    components: { ConventionSection, ConventionSectionsLines },
    props: ["cspFilters", "convention"],
    mounted() {
        this.initContent();
        this.observer = scrollManager.observeTable(this.$el, isIntersecting => {
            if (isIntersecting) {
                EventBus.$emit("convention-sections:scrolled", "content");
            } else {
                EventBus.$emit("convention-sections:scrolled", "table");
            }
        });
    },
    updated() {
        this.initContent();
    },
    destroyed() {
        this.observer.unobserve(this.$el);
    },
    watch: {
        cspFilters() {
            sectionsManager.filterSections(this.$el, this.cspFilters);
            this.$nextTick(() => EventBus.$emit("convention-sections:updated"));
        },
    },
    methods: {
        initContent() {
            if (!this.convention.cspConfig.allIncluded) {
                const availableCodes = get(this.convention, "cspConfig.availableCodes", []);
                const ccBodySelector = `.cc-body > p,.cc-body > div, .cc-body > ul, .cc-body > table, .cc-body > span, .cc-body > .cc-article`;

                // Step 1 : add common legends
                sectionsManager.commonLegends(this.$el, availableCodes, ccBodySelector);

                // Step 2 : add title tags
                sectionsManager.cspTitleTags(this.$el, availableCodes);

                // Step 3 : add csp lines
                sectionsManager.cspLines(this.$el, availableCodes);
            }

            // Update menu
            this.$nextTick(() => EventBus.$emit("convention-sections:updated"));
        },
    },
};
</script>

<style lang="sass" scoped>
.main-section
    background: white
    padding: 0 $grid-gutter * 3 $grid-gutter * 3 $grid-gutter * 3
    margin-bottom: $grid-gutter * 1.5

.filters
    margin-bottom: $grid-gutter

@media print
    .main-section
        position: relative
        padding: 0
        box-shadow: none !important
</style>
